module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Cooking/Bowl-b38ff179a7a764c19893f56e8dd0ffae6f38b19ebc99415b503ae39bbda0ed54.svg";